import React from 'react';
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

const ConfirmButtons = (props) => {
  const { confirmCallback, cancelCallback, isLoading } = props;

  return (
    <div className="flex mlr-10">
      <button
        className="ui-button10 ui-button10--blue"
        onClick={() => cancelCallback()}
        disabled={isLoading}
      >
        <span className="ui-button10--uppercase">
          <FormattedMessage id="sqft.cabinets.attributes.cancel" />
        </span>
      </button>
      <button
        className="ui-button10 ui-button10--green"
        onClick={() => confirmCallback()}
        disabled={isLoading}
      >
        <span className="ui-button10--uppercase">
          {isLoading
            ? <FormattedMessage id="sqft.cabinets.attributes.loading" />
            : <FormattedMessage id="sqft.cabinets.attributes.accept" />
          }
        </span>
      </button>
    </div>
  );
};

ConfirmButtons.propTypes = {
  confirmCallback: PropTypes.func.isRequired,
  cancelCallback:  PropTypes.func.isRequired,
  isLoading:       PropTypes.bool,
};

ConfirmButtons.defaultProps = {
  isLoading: false,
};

const mapStateToProps = (store) => ({
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmButtons);

